import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Button from "../components/Button";
import Papa from "papaparse";
import banner from "../assets/aa2.webp";
import { Link } from 'react-router-dom';
import {
  getEvaluationParametersRequest,
  showMarketDynamicsLabelingRequest,
  saveMarketDynamicsLabelingRequest,
  runDynamicsTest,
  uploadCSV,
  downloadCSV,
  dynamicsTestStatusRequest,
  runDynamicsLabelTestStatus, getParametersRequest,
} from "../services/trademasterService";
import { Buffer } from "buffer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import csvData from "../assets/Data_example.csv";
import '../styles/MarketGAN.css';
import {
  getMarketGANParametersRequest, MarketGAN_Download,
  MarketGANGenerationRequest,
  saveMarketGANGenerationRequest
} from "../services/marketGANService";
import getDateStrFromDate from "Service.tsx"
import MarketDynamicsModeling from "../assets/MarketDynamicsModeling.jpg";
export default function MarketGAN({ sessionID }) {
  const [MarketGANSessionID, setMarketGANSessionID] = useState("");
  const [fileData, setFileData] = useState("");
  const [fileMetaData, setFileMetaData] = useState("");
  const [stock_ticker, setStockTick] = useState("AAPL");
  const [start_date, setStart_date] = useState<Date>(new Date("2013-06-01"));
  const [dynamic, setDynamic] = useState("Bear");
  const minDate = new Date("2000-06-01");
  const maxDate = new Date("2023-06-01");

  const [minimumLengthOfEachChunk, setMinimumLengthOfEachChunk] =
    useState<number>();
  const [samplenumber, setSamplenumber] =
    useState<number>(64);
  const [labellingMethod, setLabellingMethod] = useState<string>();
  const [mergingMetric, setMergingMetric] = useState<string>();
  const [mergingMetricThreshold, setMergingMetricThreshold] =
    useState<number>();
  const [numberOfMarketStyle, setNumberOfMarketStyle] = useState<number>();
  const [maxLengthExpectation, setMaxLengthExpectation] = useState<number>();
  const [filterStrength, setFilterStrength] = useState<number>();
  const [bullStrength, setBullStrength] = useState<number>(0.5);
  const [flatStrength, setFlatStrength] = useState<number>(0.5);
  const [bearStrength, setBearStrength] = useState<number>(0.5);

  const [keyIndicatorColName, setKeyIndicatorColName] = useState<string>();
  const [timestampColName, setTimestampColName] = useState<string>();
  const [ticColName, setTicColName] = useState<string>();
  const [maxConstraintSpanAllowed, setMaxConstraintSpanAllowed] =
    useState<number>();
  const [testDynamicLabel, setTestDynamicLabel] = useState<number>(0);

  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [GenerationInProgress, setGenerationInProgress] =
    useState(false);
  const [testDynamicLabelDisabled, setTestDynamicLabelDisabled] =
    useState(true);

  const [parametersOptions, setParametersOptions] = useState({});
  const [stockOptions, setStockOptions] = useState(['AAPL', 'AMGN', 'AXP', 'BA', 'CAT', 'CRM', 'CSCO', 'CVX', 'DIS', 'GS', 'HD', 'HON', 'IBM', 'INTC', 'JNJ', 'JPM', 'KO', 'MCD', 'MMM', 'MRK', 'MSFT', 'NKE', 'PG', 'TRV', 'UNH', 'V', 'VZ', 'WBA', 'WMT']
  );
  const [testDynamicLabelOptions, setTestDynamicLabelOptions] = useState(
    Array<number>
  );
  const [autoFillData, setAutoFillData] = useState();
  const [figureMarketGANBase64String, setFigureMarketGANBase64String] = useState("");
  const [figureMarketGANUrl, setFigureMarketGANUrl] = useState("");
  const [figure2Base64String, setFigure2Base64String] = useState("");
  const [figure2Url, setFigure2Url] = useState("");
  const [figure3Base64String, setFigure3Base64String] = useState("");
  const [figure3Url, setFigure3Url] = useState("");
  const [optionSelected, setOptionSelected] = useState({
    stock_ticker: "",
    start_date: "",
    dynamic: "",
    sample_number: "",
  });
  const [requestOutput, setRequestOutput] = useState("");
  const [requestOutput2, setRequestOutput2] = useState("");

  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  const createSelectItems = (
    options: Array<string | number>
  ): JSX.Element[] => {
    let items: JSX.Element[] = [];
    if (options === undefined) {
      return items;
    }
    for (let i = 0; i <= options.length; i++) {
      if (options[i] !== undefined) {
        items.push(
          <option key={i} value={options[i]}>
            {options[i]}
          </option>
        );
      }
    }
    return items;
  };

  const notifyToast = (text, type) => {
    if (type == "success") {
      toast.success(text);
    } else if (type == "error") {
      toast.error(text);
    } else if (type == "info") {
      toast.info(text);
    }
  };

  async function GenerationStatusloop(sessionID) {
    let MDMEnd = false;
    while (MDMEnd === false) {
      if (MDMEnd) {
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, 10000));
      // do something here
      // test-status request
      let promise = dynamicsTestStatusRequest(sessionID);
      notifyToast(
        "Request submitted! Please be patient...",
        "info"
      );
      promise
        // eslint-disable-next-line no-loop-func
        .then((res) => {
          console.log("MDMStatusRequest", res);
          console.log("MDMStatusRequest.sessionid", res.session_id);
          // setEvaluationSessionID(res.session_id);
          let newStr = res.info;
          setRequestOutput(newStr);
          if (res.MDM_end === true) {
            // setEvaluationSessionID(res.session_id);
            setRequestOutput(res.info);
            notifyToast(
              "Market Dynamics Modeling Response Received! Output Updated",
              "success"
            );
            setFigureMarketGANBase64String(res.market_dynamic_labeling_visulization);
            setFigure2Base64String(res.market_dynamic_labeling_analysis);
            MDMEnd = true;
            setGenerationInProgress(false);
          }
          notifyToast(
            "Market Dynamics Modeling status response received! Output updated. Please be patient..., the modeling is still running...",
            "success"
          );
        })
        .catch((error) => {
          console.log("error", error);
          notifyToast(error, "error");
          setGenerationInProgress(false);
        });
    }
  }

  const getDateStrFromDate = (date: Date | undefined) => {
    if (date === undefined) {
      return "";
    }
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    let dateStr = `${year}-${month + 1}-${day}`;
    return dateStr;
  };

  // Function to create <option> items
  // const createSelectItems = (options) => {
  //     return options.map((option, index) => (
  //         <option key={index} value={option}>
  //             {option}
  //         </option>
  //     ));
  // };


  const handleOptionChange = (e, option_name) => {
    setOptionSelected({ ...optionSelected, [option_name]: e.target.value });
  };

  const MarkeGANGeneration = () => {
    setGenerationInProgress(true);

    const optionSelected = {
      stock_ticker: stock_ticker,
      start_date: getDateStrFromDate(start_date),
      dynamic: dynamic,
      sample_number: samplenumber,
      bear_strength: bearStrength,
      flat_strength: flatStrength,
      bull_strength: bullStrength,


    };
    console.log('option', optionSelected);
    let promise = MarketGANGenerationRequest(
      MarketGANSessionID,
      optionSelected
    );

    promise
      .then(async (res) => {
        console.log('MarketGANGeneration', res);
        // console.log(res.session_id);
        // await setEvaluationSessionID(res.session_id);
        // console.log("evaluationSessionID", evaluationSessionID);
        // console.log(res.session_id);
        // GenerationStatusloop(res.session_id);
        await setMarketGANSessionID(res.session_id);
        // console.log(MarketGANSessionID);
        setFigureMarketGANBase64String(res.fig);
        // console.log('res.figure',res.fig);
        // console.log("figure1Base64String", figure1Base64String);
        setGenerationInProgress(false);

      })
      .catch((error) => {
        console.log("error", error);
        notifyToast("Error!!!", "error");
      });
  };

  const saveDownloadGeneratedDataOnClick = (MarketGANSessionID) => {
    console.log(MarketGANSessionID);

    let promise = saveMarketGANGenerationRequest(MarketGANSessionID);
    promise
      .then((res) => {
        notifyToast(
          "Save Current Generation Response Received! Output Updated",
          "success"
        );
        let promise2 = MarketGAN_Download(res.session_id);  // Assuming your function name stays the same
        promise2
          .then((res) => {
            console.log("download response:", res);
            notifyToast("Download .npy Success!", "success");

            // Create a Blob from the response data
            const npyBlob = new Blob([res.data], { type: "application/octet-stream" });

            // Create a temporary URL for the Blob
            const npyUrl = window.URL.createObjectURL(npyBlob);

            // Create a link element
            const link = document.createElement("a");
            link.href = npyUrl;
            link.setAttribute("download", `${res.filename}.npy`); // Changed file extension to .npy

            // Simulate a click on the link to trigger the download
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(npyUrl);
            console.log("session_id for get parameters", res.session_id);
            let promise = getEvaluationParametersRequest(res.session_id);
            promise
              .then((res) => {
                console.log(res.test_dynamic_number);
                setTestDynamicLabelOptions(res.test_dynamic_number);
                setTestDynamicLabelDisabled(false);
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((error) => {
            // Handle error
            console.error("Error downloading .npy:", error);
          });
      })
      .catch((error) => {
        console.log("error", error);
        notifyToast("Error!!!", "error");
      });
  };

  const handleBlur = () => {
    if (start_date < minDate || start_date > maxDate) {
      toast.error("Please selected a date from 2000-06-01 to 2023-06-01");
    }
  };

  const datePickerRef = useRef(null);

  useEffect(() => {
    const handleBlur = () => {
      const inputValue = new Date(datePickerRef.current.input.value);
      if (inputValue < minDate || inputValue > maxDate) {
        toast.error("Selected date is out of range!");
      }
    };

    if (datePickerRef.current) {
      const inputElement = datePickerRef.current.input;
      inputElement.addEventListener('blur', handleBlur);

      // Cleanup: remove event listener when component unmounts
      return () => {
        inputElement.removeEventListener('blur', handleBlur);
      };
    }
  }, [minDate, maxDate, datePickerRef]);



  useEffect(() => {
    if (figureMarketGANBase64String) {
      //convert base64 to utf8array, then to Blob
      const byteString = Buffer.from(figureMarketGANBase64String, "base64");
      const blob = new Blob([byteString.buffer]);
      const url = URL.createObjectURL(blob);
      // Set the URL as the imageUrl state variable
      setFigureMarketGANUrl(url);
      console.log("figure1Url", figureMarketGANUrl)
    }
  }, [figureMarketGANBase64String]);






  function handleFileInputChange(event) {
    const file = event.target.files[0];
    console.log(file);
    setFileMetaData(file);

    Papa.parse(event.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        console.log(results.data);
        setFileData(results.data);
      }
    });
  }


  // useEffect(() => {
  //     if (
  //         parametersOptions === "" ||
  //         parametersOptions === undefined
  //     ) {
  //         return;
  //     }
  //     console.log('parametersOptions',parametersOptions);
  //   let newdynamic = parametersOptions.dynamic;
  //   setDynamic(newdynamic);
  //   let newStockTick = parametersOptions.stock_tick;
  //   setStockTick(newStockTick);
  //   let newStartDate = parametersOptions.start_date;
  //   console.log(newStartDate);
  //   setStart_date(new Date(newStartDate));
  //   let newSampleNumber =
  //       parametersOptions.sample_number;
  //   setSamplenumber(newSampleNumber);
  // });

  useEffect(() => {
    let promise = getMarketGANParametersRequest();
    promise
      .then((res) => {
        // console.log(new Date("2016-01-01"));
        // console.log('start_date',start_date);
        //   console.log('res',res);
        //   console.log('before',parametersOptions);
        // setParametersOptions(res);
        //   console.log('after',parametersOptions);
        // // console.log('res');
        // // console.log(res);
      })
      .then(() => {
        console.log('then');
        if (sessionID !== "") {
          setMarketGANSessionID(sessionID);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);





  function Tooltip({
    children,
    tooltipText = "Tooltip Text",
    position = "top",
  }) {
    return (
      <div className="tooltip-trigger">
        {children}
        <div className={`tooltip tooltip-${position}`}>
          {tooltipText}
        </div>
      </div>
    )
  }
  const CollapsibleBox = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="collapsible-box">
        <button className="collapsible-button" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "Hide Explanation of Parameters" : "Show Explanation of Parameters"}
        </button>

        {isOpen && (
          <div className="collapsible-content">
            <p className="instructions-container">
              <li>
                <strong>Stock Ticker</strong>: We provide 29 stock tickers from DJIA index, excluding DOW due to insufficient data.
              </li>
              <li>
                <strong>Sample Number</strong>: The number of samples you want to generate with the given parameters with randomness. We offer a range from 64 to 1024.
              </li>
              <li>
                <strong>Start Date</strong>: The start date of your generated data. The model will use the data before the start date as the history. While the model is able to take in any data as context, we only use real history data here. The range of the start date is from 2000-06-01 to 2023-06-01.
              </li>
              <li>
                <strong>Market Dynamics</strong>: The market dynamics you want to have on your generated data. We offer three options: <strong>Bear</strong>, <strong>Bull</strong> and <strong>Custom</strong> . When choosing <strong>Custom</strong>, the market will be generated with the strength parameters.
              </li>
            </p>
          </div>
        )}
      </div>
    );
  };

  const CollapsibleBox_intro = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="collapsible-box">
        <button className="collapsible-button" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "Hide introduction" : "What is this simulator?"}
        </button>

        {isOpen && (
          <div className="collapsible-content">

            <h2>Overview</h2>
            <p className="instructions-container">
              This market simulator is built based on the <a
                href="https://arxiv.org/abs/2309.07708"
                style={{ textDecoration: "underline" }}
                target="_blank"
              >
                Market-GAN
              </a> model. The simulator generates counterfactual OHLC data samples with a given <strong>history</strong> and a <strong>future market dynamics</strong> as control for a <strong>stock</strong>.
              <br></br>
              <br></br>
              <h2>Data Generation</h2>
              For example, the model generates
              possible future market for <strong>AAPL</strong> from <strong>2013-06-01</strong> if a positive event happens and lead to a <strong>bear</strong> market based on the history market.
              <br></br>
              <br></br>
              The generated data is based on the <strong>prediction</strong> of the given history and the <strong>market dynamics</strong> as modulation. So a 'Bear' dynamic does not mean the market will go down, it means the market will go down <strong>relative to the prediction</strong> of the given history of a stock.
              <br></br>
              <br></br>
              <strong>Generated Data Format</strong> :
              The generated data will be downloaded as a npy file in a array of (sample number, chunk length, feature number). For this toolbox, the simulator generates a 30 ticks day-level ['low','open','close','high'] data for each sample.
              <br></br>
              <br></br>
              <h2>Example Usages</h2>
              Possible usages of the this simulator are:
              <ol>
                <li> <strong>Data Augmentation</strong>: As stated in the <a
                  href="https://arxiv.org/abs/2309.07708"
                  style={{ textDecoration: "underline" }}
                  target="_blank"
                >
                  Market-GAN paper
                </a>, combining the generated data with the original data can improve the performance of the models on downstream prediction task.
                </li>
                <li> <strong>Stress Testing</strong>: Market-GAN is able to generate extreme markets under the control of market dynamics. The generated data can be used to test the robustness of the models.
                </li>
              </ol>
            </p>

          </div>
        )}
      </div>
    );
  };


  return (
    <div>


      <div className="homeMain">
        <div className="do4">
          <div className="what2">Market Simulator</div>
          <div className="how2">
            <div className="title2">Overview</div>
            <div style={{ marginTop: '20px' }}>This market simulator is built based on the Market-GAN model. The simulator generates counterfactual OHLC data samples with a given history and a future market dynamics as control for a stock.</div>
            <div className="title2" style={{ marginTop: '20px' }}>Data Generation</div>
            <div style={{ marginTop: '20px' }}>For example, the model generates possible future market for AAPL from 2013-06-01 if a positive event happens and lead to a bear market based on the history market.</div>
            <div>The generated data is based on the prediction of the given history and the market dynamics as modulation. So a 'Bear' dynamic does not mean the market will go down, it means the market will go down relative to the prediction of the given history of a stock.</div>
            <div>Generated Data Format : The generated data will be downloaded as a npy file in a array of (sample number, chunk length, feature number). For this toolbox, the simulator generates a 30 ticks day-level ['low','open','close','high'] data for each sample.</div>
            <div className="title2" style={{ marginTop: '20px' }}>Example Usages</div>
            <div style={{ marginTop: '20px' }}>Possible usages of the this simulator are:</div>
            <div>1.Data Augmentation: As stated in the Market-GAN paper, combining the generated data with the original data can improve the performance of the models on downstream prediction task.</div>
            <div>2.Stress Testing: Market-GAN is able to generate extreme markets under the control of market dynamics. The generated data can be used to test the robustness of the models.</div>
          </div>
        </div>
        <img
          src={banner}
          alt="github Icon"
          className="banner3"
          style={{height:'500px'}}
        />

      </div>



      <div className="buzhou">
        <div className="market">
          <div >
            <div className="word11">{'\u2460'} Set Simulation Parameters</div>
            <div className="word12">
              <p className="">
                <li>
                  <strong>Stock Ticker</strong>: We provide 29 stock tickers from DJIA index, excluding DOW due to insufficient data.
                </li>
                <li>
                  <strong>Sample Number</strong>: The number of samples you want to generate with the given parameters with randomness. We offer a range from 64 to 1024.
                </li>
                <li>
                  <strong>Start Date</strong>: The start date of your generated data. The model will use the data before the start date as the history. While the model is able to take in any data as context, we only use real history data here. The range of the start date is from 2000-06-01 to 2023-06-01.
                </li>
                <li>
                  <strong>Market Dynamics</strong>: The market dynamics you want to have on your generated data. We offer three options: <strong>Bear</strong>, <strong>Bull</strong> and <strong>Custom</strong> . When choosing <strong>Custom</strong>, the market will be generated with the strength parameters.
                </li>
              </p>
            </div>

            <div className="session">
              {/*<span className="fw-lighter">Session ID: {evaluationSessionID}</span>*/}
              <span className="fw-lighter"></span>
            </div>
            <div className="row my-2">
              <div className="col">
                {/*<div className="mb-3">Choose one of Stock Ticker</div>*/}
                <div>
                  <div className="">

                    <div className="seatIP">Stock Ticker</div>
                    <select
                      className="form-select"
                      id="stockSelect"
                      style={{ marginTop: '10px' }}
                      onChange={(e) => setStockTick(e.target.value)}
                    >
                      {/*<option value="">Choose a stock</option>*/}
                      {createSelectItems(stockOptions)}
                    </select>
                  </div>
                </div>
              </div>
              {/*<div className="col">*/}
              <div className=" col tooltip-container">
                <div className="seatIP">Sample Number</div>
                <input
                  style={{ marginTop: '10px' }}
                  type="number"
                  id="samplenumber"
                  className="form-control"
                  min="64"
                  max='1024'
                  onChange={(e) => setSamplenumber(Number(e.target.value))}
                  value={samplenumber}
                />
              </div>
              {/*</div>*/}
            </div>
            <div className="row my-2">
              <div className="col">
                <div className="seatIP">Start Date</div>
                <DatePicker
                  className="datepicker"
                  id="startDatePicker"
                  dateFormat="yyyy-MM-dd"
                  placeholderText="YYYY-MM-DD"
                  selected={start_date}
                  onChange={(date) => {
                    if (date < minDate || date > maxDate) {
                      toast.error("Please selected a date from 2000-06-01 to 2023-06-01");
                    } else {
                      setStart_date(date);
                      let str = getDateStrFromDate(date);
                      let temp = { ...optionSelected };
                      temp.start_date = str;
                      setOptionSelected(temp);
                    }
                  }}
                  onBlur={handleBlur}
                  minDate={minDate}
                  maxDate={maxDate}
                />
              </div>
              <div className=" col">
                <div className="seatIP">Market Dynamics</div>
                <select
                  className="form-select"
                  id="floatingSelect"
                  style={{ marginTop: '10px' }}
                  onChange={(e) => setDynamic(e.target.value)}
                  value={mergingMetric}
                >
                  <option value="Bear">Bear</option>
                  <option value="Bull">Bull</option>
                  {/*<option value="Neutral">Neutral</option>*/}
                  <option value="Custom">Custom</option>
                </select>
              </div>
            </div>
            {/* <div className="row">
        <div className="offset-4 col-4">
          <button
            className="btn btn-primary"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseExample"
            aria-expanded="false"
            aria-controls="collapseExample"
            style={{ width: "100%", fontSize: "16px" }}
          >
            Custom Dynamics Parameters <span className="caret"></span>
          </button>
        </div>
      </div> */}
            <div id="collapseExample" >
              <div className="row my-2" style={{ marginBottom: '40px' }}>
                <div className="col">
                  <label htmlFor="customRange1" className="form-label seatIP">
                    Bear Market Strength: {bearStrength}
                  </label>
                  <input
                    type="range"
                    className="form-range"
                    id="customRange1"
                    max={1}
                    min={0}
                    step="0.01"
                    value={bearStrength}
                    onChange={(e) => setBearStrength(Number(e.target.value))}
                  />
                </div>
                <div className="col">
                  <label htmlFor="customRange1" className="form-label seatIP"> Sideways Market Strength: {flatStrength}
                  </label>
                  <input
                    type="range"
                    className="form-range"
                    id="customRange1"
                    max={1}
                    min={0}
                    step="0.01"
                    value={flatStrength}
                    onChange={(e) => setFlatStrength(Number(e.target.value))}
                  />
                </div>
                <div className="col">
                  <label htmlFor="customRange1" className="form-label seatIP">
                    Bull Market Strength: {bullStrength}
                  </label>
                  <input
                    type="range"
                    className="form-range"
                    id="customRange1"
                    max={1}
                    min={0}
                    step="0.01"
                    value={bullStrength}
                    onChange={(e) => setBullStrength(Number(e.target.value))}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="row market"  style={{width:'1200px',margin:'0 auto'}}>
        <div className="col button-col" style={{marginTop:'50px'}}>
          <Button
            type="primary"
            onClick={() => {
              setFigureMarketGANUrl("");
              setFigureMarketGANBase64String("");
              notifyToast(
                "Current Generation Request submitted! Please Be Patient...",
                "info"
              );
              setRequestOutput("");
              MarkeGANGeneration();
            }}
            disabled={GenerationInProgress}
          >
            {'\u2461'} Generate Data Samples
          </Button>
        </div>
        <div className="col button-col" style={{marginTop:'50px'}}>
          <Button
            type="primary"
            onClick={() => {
              notifyToast(
                "Downloading generated data! Please Be Patient...",
                "info"
              );
              setRequestOutput("");
              saveDownloadGeneratedDataOnClick(MarketGANSessionID);
            }}
          >
            {'\u2462'} Download Data Samples
          </Button>
        </div>
      </div>

      {/*<div className="row my-2">*/}

      {/*    <pre className="output-container">*/}
      {/*    {figure1Url !== "" && (*/}
      {/*      <div*/}
      {/*        style={{*/}
      {/*          position: "relative",*/}
      {/*          width: "100%",*/}
      {/*          paddingTop: "100%"*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        <img*/}
      {/*          src={figure1Url}*/}
      {/*          alt="analysis-graph"*/}
      {/*          className="img-fluid"*/}
      {/*          style={{*/}
      {/*            position: "absolute",*/}
      {/*            top: 0,*/}
      {/*            left: 0,*/}
      {/*            height: "620px",*/}
      {/*            objectFit: "cover"*/}
      {/*          }}*/}
      {/*        />*/}
      {/*      </div>*/}
      {/*    )}*/}
      {/*      </pre>*/}
      {/*</div>*/}
      <div className="row my-2 market"  style={{width:'1200px',margin:'0 auto'}}>
        <h3 className="mt-5 main1">Candlestick Chart of Generated Data</h3>
        <pre className="output-container" style={{ height: '620px', overflow: 'hidden', position: 'relative' }}>
          {figureMarketGANUrl !== "" && (
            <div style={{ height: '100%', position: 'relative' }}>
              <img
                src={figureMarketGANUrl}
                alt="analysis-graph"
                style={{
                  height: '100%',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)'
                }}
              />
            </div>
          )}
        </pre>
      </div>




      {/*<div className="row my-2">*/}
      {/*  <pre className="output-container" style={{display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden"}}>*/}
      {/*  {figure1Url !== "" && (*/}
      {/*      <div*/}
      {/*          style={{*/}
      {/*              position: "relative",*/}
      {/*              width: "100%"*/}
      {/*          }}*/}
      {/*      >*/}
      {/*          <img*/}
      {/*              src={figure1Url}*/}
      {/*              alt="analysis-graph"*/}
      {/*              className="img-fluid"*/}
      {/*              style={{*/}
      {/*                  position: "absolute",*/}
      {/*                  top: "50%",*/}
      {/*                  left: "50%",*/}
      {/*                  transform: "translate(-50%, -50%)",*/}
      {/*                  height: "98%",*/}
      {/*                  objectFit: "contain"  // or remove this line if aspect ratio is not a concern*/}
      {/*              }}*/}
      {/*          />*/}
      {/*      </div>*/}
      {/*  )}*/}
      {/*  </pre>*/}
      {/*</div>*/}




      <ToastContainer />
    </div>
  );
}
